import Technician from '../interfaces/Technician';

export const INITIAL_VALUES: Technician = {
    group: '',
    name: '',
    userAD: ''
}